import styled from 'styled-components';

import GatekeepingStop from './component';

export default styled(GatekeepingStop)`
  border-bottom: 1px solid var(--grey200);
  &:first-child {
    border-radius: 8px 8px 0 0;
  }

  &:last-child {
    border-bottom: 0;
    border-radius: 0 0 8px 8px;
  }
  .stop {
    overflow: hidden;

    &__container {
      display: flex;
      align-items: stretch;
      min-height: 80px;
    }

    &__times {
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      flex-direction: column;
      font-weight: bold;
      padding: 12px 8px 0 12px;
      white-space: nowrap;
      min-width: 100px;
      max-width: 100px;
      .id {
        font-weight: normal;
        color: var(--grey700);
      }
    }

    &__address {
      min-width: 270px;
      max-width: 270px;
      padding: 12px 8px 12px 8px;
      .hint {
        color: var(--grey700);
        line-height: normal;
      }
    }

    &__comments {
      padding: 12px 12px 12px 8px;
      min-width: 300px;
      max-width: 300px;
      background-color: var(--grey100);
      color: var(--grey700);
    }

    &__stop-type {
      width: 40px;
      display: flex;
      justify-content: center;
      align-items: flex-start;
      padding-top: 12px;
      border-left: 2px solid var(--grey100);
    }

    &__loads {
      padding: 12px 12px 12px 0;
      display: flex;
      flex-direction: column;
      min-width: 90px;
    }

    &__load {
      display: flex;
      &__pallets {
        min-width: 35px;
      }
      &__sizes {
        min-width: 105px;
      }
      &__weight {
        min-width: 60px;
      }
      > div {
        margin-right: 8px;
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
`;
